<script lang="ts" setup>
import H1Heading from "~/components/H1Heading.vue";
import { useHelper } from "~/composables/helper";
import TrialForm from "~/components/freeTrial/TrialForm.vue";
import type Product from "~~/types/Product";

// Data
const route = useRoute();
const arySlug = route.params.slug;
const slugOrId = arySlug[0] as string;
const filtersAndFields = [`fields=${useHelper().collectionProductFields}`];
filtersAndFields.push(isNaN(+slugOrId) ? `filter[slug:is]=${slugOrId}` : `filter[id:is]=${slugOrId}`);
const products = ref([]);
products.value = await useHelper().getCollection("products", filtersAndFields.join("&"), 1);

if (products.value && products.value?.length <= 0) {
    await navigateTo("/");
}
const product = ref({} as Product);
product.value = products.value ? products.value[0] : ({} as Product);

// Make sure this product actually link to CW
if (product.value && !product.value?.coursewave_product_id) {
    await navigateTo(`/products/${product.value.c_slug}`);
}
</script>

<template>
    <div class="pb-10">
        <H1Heading
            size="text-3xl md:text-4xl"
            class="mb-6"
            >Try free for two weeks</H1Heading
        >
        <TrialForm
            v-if="product"
            :product="product"
        />
        <div
            v-else
            class="text-abc-red text-center"
        >
            Product not found. Please try again.
        </div>
    </div>
</template>

<style scoped></style>
